export default {
  "label": "_label_el0ia2"
};
